<template>
  <div class="checkbox_wrap">
    <div class="checkbox">
      <img
        v-show="!isChecked"
        class="checkbox_label"
        src="@/assets/icon_check_normal_green.png"
        @click="onChangeCheckBox(true)"
      />
      <img
        v-show="isChecked"
        class="checkbox_label"
        src="@/assets/icon_check_select_green.png"
        @click="onChangeCheckBox(false)"
      />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CheckBox',
  data() {
    return {
      isChecked: false
    }
  },
  props: {
    checked: Boolean,
    onChange: Function
  },
  methods: {
    onChangeCheckBox(check) {
      this.isChecked = check
      if (this.onChange) {
        this.onChange(check)
      }
    }
  },
  created() {
    this.isChecked = this.checked
  }
}
</script>

<style scoped>
.checkbox_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox {
  position: relative;
  height: 0.14rem;
  width: 0.14rem;
  margin-inline-end: 0.04rem;
}

.checkbox_label {
  position: absolute;
  top: 0;
  left: 0;
  height: 0.14rem;
  width: 0.14rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckBox.vue